import { render, staticRenderFns } from "./AgentProfile.vue?vue&type=template&id=2267b028"
import script from "./AgentProfile.vue?vue&type=script&lang=js"
export * from "./AgentProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports